import { getInventoryAsyncResponse } from "./types";
import * as inventoryActions from "./inventories.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_INVENTORY, retrieveToken } from "../../../helpers/api";

export function* getInventorys(action: ReturnType<typeof inventoryActions.getInventoryAsync.request>) {
  try {
    const page = action.payload.page ? action.payload.page : 1;
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_INVENTORY.GET_INVENTORIES(page), token);
    if (result.status === 200) {
      const parsed: getInventoryAsyncResponse = yield call(result.json.bind(result));
      yield put(inventoryActions.getInventoryAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(inventoryActions.getInventoryAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(inventoryActions.getInventoryAsync.failure(parsed));
  }
}

export default function* inventoriesSagaGetInventory() {
  yield takeEvery(inventoryActions.getInventoryAsync.request, getInventorys);
}
